import { IToggleStyleProps, IToggleStyles } from '@fluentui/react/lib/Toggle';
import { ITheme } from '@fluentui/react/lib/Styling';
import { SecondaryColors } from '../teams-colors';

export function getToggleStyles(
  themeName: string,
  _theme: ITheme,
  background?: string
) {
  return (props: IToggleStyleProps): Partial<IToggleStyles> => {
    const { checked, theme } = props;
    const { palette } = theme;

    let PILL_BACKGROUND_COLOR = palette.neutralLight;
    let PILL_CHECKED_BACKGROUND_COLOR = SecondaryColors.appGreen;
    let PILL_BORDER = 'none';
    let PILL_FOCUS_BORDER = palette.themePrimary;

    if (themeName === 'dark') {
      PILL_BACKGROUND_COLOR = palette.white;
    }

    if (themeName === 'contrast') {
      PILL_BORDER = `2px solid ${palette.black}`;
      PILL_CHECKED_BACKGROUND_COLOR = palette.themePrimary;
      PILL_FOCUS_BORDER = palette.themeDark;
    }

    // If this toggle button is on gray background
    if (background === 'gray') {
      PILL_BACKGROUND_COLOR = palette.white;
    }
    const styles = {
      root: {
        marginBottom: '4px',
        selectors: {
          '.ms-Fabric--isFocusVisible &': {
            selectors: {
              button: {
                selectors: {
                  ':focus::after': {
                    outline: 'none',
                    border: `2px solid ${PILL_FOCUS_BORDER}`,
                    borderRadius: '20px'
                  }
                }
              }
            }
          }
        }
      },
      pill: [
        !checked && {
          backgroundColor: PILL_BACKGROUND_COLOR,
          border: PILL_BORDER,
          height: '20px',
          width: '40px',
          padding: '0 3px',
          selectors: {
            ':hover': {
              border: PILL_BORDER,
              backgroundColor: PILL_BACKGROUND_COLOR
            }
          }
        },
        checked && {
          backgroundColor: PILL_CHECKED_BACKGROUND_COLOR,
          border: 'none',
          height: '20px',
          width: '40px',
          padding: '0 3px',
          selectors: {
            ':hover': {
              backgroundColor: PILL_CHECKED_BACKGROUND_COLOR
            }
          }
        },
        { borderColor: 'transparent' }
      ],
      thumb: [
        !checked && {
          background: palette.neutralDark,
          height: '14px',
          width: '14px'
        },
        checked && {
          background: palette.white,
          height: '14px',
          width: '14px'
        }
      ]
    } as Partial<IToggleStyles>;

    return styles;
  };
}
